import _pickBy from "lodash/pickBy";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import FastqFileType from 'const/enums/FastqFileType';
import createMemoizedSelector from 'redux/selectors/createMemoizedSelector';
var getFastqFiles = function getFastqFiles(secondaryAnalysisId) {
  var fileType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return function (state) {
    var _state$secondaryAnaly;
    var fileTypes = fileType ? [fileType] : [FastqFileType.IMMUNE_FASTQ, FastqFileType.WT_FASTQ];
    return _pickBy((_state$secondaryAnaly = state[secondaryAnalysisId]) === null || _state$secondaryAnaly === void 0 ? void 0 : _state$secondaryAnaly.files.data, function (file) {
      return fileTypes.includes(file.type);
    });
  };
};
export default createMemoizedSelector(getFastqFiles);